import React, { useState, useEffect } from "react";
import commonFunc from "src/utils/commonFunc";
import PrintOrderPopup from "src/orders/components/PrintOrderPopup";
import BackRouteButton from "src/common/components/BackRouteButton";

import { useHistory } from "react-router-dom";

import {
  Table,
  Card,
  Modal,
  Button,
  Space,
  Input,
  message,
  Radio,
  Spin,
} from "antd";
import {
  EyeOutlined,
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  CarOutlined,
  CreditCardOutlined,
  FieldNumberOutlined,
  CalendarOutlined,
  PrinterOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";

import "./index.css";

const { formatDate } = commonFunc;

export default ({
  counteragentOrders,
  cancelOrder,
  profile,
  shipOrder,
  cancelShipOrder,
  selectedCounteragent,
  getCounteragentOrders,
}) => {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [print, handlePrint] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [filter, setFilter] = useState("all");
  const [dataSource, setDataSource] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [columnsForModal, setColumnsForModal] = useState([]);
  const [columns, setColumns] = useState([]);
  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleFilterChange = (e) => {
    const value = e.target.value;
    setFilter(value);
  };

  const filterOrders = (filter, counteragentOrders, searchValue) => {
    let filteredData = counteragentOrders || [];

    if (searchValue) {
      filteredData = filteredData.filter((order) => {
        const searchValueLower = searchValue.toLowerCase();
        const searchNumber = parseFloat(searchValue);

        return (
          order.counteragent.firstname
            ?.toLowerCase()
            .includes(searchValueLower) ||
          order.counteragent.lastname
            ?.toLowerCase()
            .includes(searchValueLower) ||
          order.counteragent.additionalName
            ?.toLowerCase()
            .includes(searchValueLower) ||
          order.counteragent.firm?.toLowerCase().includes(searchValueLower) ||
          order?.comment?.toLowerCase().includes(searchValueLower) ||
          order.serial === searchNumber ||
          order.totalWeight === searchNumber ||
          order.totalSum === searchNumber
        );
      });
    }

    switch (filter) {
      case "opened":
        return filteredData.filter((order) => order.state === "opened");
      case "complete":
        return filteredData.filter((order) => order.state === "complete");
      case "cancelled":
        return filteredData.filter((order) => order.cancelled);
      case "notPayed":
        return filteredData.filter((order) => !order.paid && !order.cancelled);
      case "notShipped":
        return filteredData.filter(
          (order) => !order.shipped && !order.cancelled
        );
      case "withReturns":
        return filteredData.filter(
          (order) => order.returns.length > 0 && !order.cancelled
        );
      default:
        return filteredData;
    }
  };

  const prepareDataSource = (data) => {
    const sortedData = [...data].sort((a, b) => b.serial - a.serial);

    return sortedData.map((order) => ({
      ...order,
      key: order._id,
      date: formatDate(order.date).slice(0, 100),
      counteragentName: `${order.counteragent.firm || ""} ${
        order.counteragent.lastname || ""
      } ${order.counteragent.firstname || ""}
    ${order.counteragent.additionalName || ""}`,
      driverName: order.driver
        ? `${order.driver.firm || ""} ${order.driver.lastname || ""}
    ${order.driver.firstname || ""} ${order.driver.additionalName || ""}`
        : "",
      deliveryAddress: order.deliveryAddress
        ? `${order.deliveryAddress || ""}`
        : "",
      deliveryCost: order.deliveryCost ? `${order.deliveryCost || ""}` : "",
      totalSumPaid: `${order.totalSumPaid} / ${order.totalSum}`,
      payments: order.payments
        .map((payment) => {
          if (!payment.cancelled) {
            return {
              ...payment,
            };
          }
          return null;
        })
        .filter(Boolean),
      instances: order.instances.map((instance, idx) => ({
        ...instance,
        key: `${order._id}-${idx}`,
        title: instance.title.replace(/пшеничная|Хлебопекарная/g, ""),
        cost: Number((instance.price * instance.weight).toFixed(2)),
      })),
    }));
  };

  const handleEditOrder = async (order) => {
    history.push({
      pathname: `/orders/edit`,
      state: {
        order,
      },
    });
  };

  const handleCancelOrder = async (values) => {
    setLoading(true);
    values.creatorId = profile._id;
    var result = await cancelOrder(values);

    if (result.success) {
      await getCounteragentOrders(selectedCounteragent);
      message.success("Order successfully canceled!");
      setLoading(false);
    } else {
      message.error(result.message || "Failed to cancel the order!");
      setLoading(false);
    }
  };
  const handleShipOrder = async (values) => {
    setLoading(true);
    values.creatorId = profile._id;
    var result = await shipOrder(values);

    if (result.success) {
      await getCounteragentOrders(selectedCounteragent);
      message.success("Order successfully shipped!");
      setLoading(false);
    } else {
      message.error(result.message || "Failed to ship the order!");
      setLoading(false);
    }
  };
  const handleCancelShipOrder = async (values) => {
    setLoading(true);
    values.creatorId = profile._id;
    var result = await cancelShipOrder(values);

    if (result.success) {
      await getCounteragentOrders(selectedCounteragent);
      message.success("Order shipment canceled!");
      setLoading(false);
    } else {
      message.error(result.message || "Failed to cancel shipment!");
      setLoading(false);
    }
  };

  const handlePayForOrder = async (order) => {
    history.push({
      pathname: `/counters/order`,
      state: { order },
    });
  };

  const showConfirmCancel = (order) => {
    Modal.confirm({
      title: "Are you sure you want to cancel this order?",
      icon: <ExclamationCircleOutlined />,
      content: "This action cannot be undone.",
      okText: "Yes, cancel",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        handleCancelOrder(order);
      },
      onCancel() {
        console.log("Cancelled");
      },
    });
  };
  const showConfirmShipping = (order) => {
    Modal.confirm({
      title: "Are you sure you want to ship the order?",
      icon: <ExclamationCircleOutlined />,
      content: 'This action changes the status of the order to "shipped".',
      okText: "Yes, ship",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        handleShipOrder(order);
      },
      onCancel() {
        console.log("Cancelled");
      },
    });
  };
  const showConfirmCancelShipping = (order) => {
    Modal.confirm({
      title: "Are you sure you want to cancel the shipment?",
      icon: <ExclamationCircleOutlined />,
      content: 'This action changes the status of the order to "not shipped".',
      okText: "Yes, cancel",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        handleCancelShipOrder(order);
      },
      onCancel() {
        console.log("Cancelled");
      },
    });
  };

  const showModal = (order) => {
    setSelectedOrder(order);
    setIsModalVisible(true);
  };

  const columnsForModalofPayments = [
    {
      title: (
        <div>
          <FieldNumberOutlined />/<CalendarOutlined />
        </div>
      ),
      dataIndex: "serial",
      key: "serial",
      render: (_, record) => (
        <span className="column-content-font">
          {record.serial} / {formatDate(record.date).slice(0, 20)}
        </span>
      ),
    },
    {
      title: <span className="column-title-font">Amount</span>,
      dataIndex: "sum",
      key: "sum",
      render: (text, record) =>
        record.cancelled ? (
          <span className="table-title-font">CANCELLED</span>
        ) : (
          <span className="column-content-font">{text} rub.</span>
        ),
    },
    {
      title: <span className="column-title-font">To</span>,
      dataIndex: "counter1",
      key: "counter1",
      render: (text) => (
        <span className="column-content-font">{text.title} </span>
      ),
    },
    {
      title: <span className="column-title-font">Payment method</span>,
      dataIndex: "type",
      key: "type",
      render: (text) => <span className="column-content-font">{text}</span>,
    },
  ];

  const OrderModalContent = () => {
    if (!selectedOrder) {
      return null;
    }

    const prepareOrderForPrint = (order) => {
      var originalOrder = counteragentOrders.find((o) => o._id === order._id);
      order.instances = originalOrder.instances;
      return order;
    };

    const {
      date,
      serial,
      counteragentName,
      instances,
      totalSumPaid,
      totalSum,
      totalWeight,
      comment,
      cancelled,
      shipped,
      paid,
      payments,
      driverName,
      deliveryAddress,
      deliveryCost,
    } = selectedOrder;
    return (
      <Card
        size="small"
        title={`Order №${serial}`}
        extra={
          <div className="common-modal__buttons-container">
            <span className="column-title-font">
              Order date: {cancelled ? "CANCELLED" : date.slice(0, 20)}
            </span>
            <Button
              disabled={cancelled}
              className="common-table-button"
              type="link"
              size="small"
              icon={<PrinterOutlined />}
              onClick={() => {
                var preparedOrder = prepareOrderForPrint(selectedOrder);
                setSelectedOrder(preparedOrder);
                handlePrint(true);
              }}
            />
          </div>
        }
      >
        <span className="column-title-font">Buyer:</span>
        <span className="column-content-font">{counteragentName}</span>
        <br />
        <br />
        <Table
          dataSource={instances}
          columns={columnsForModal}
          pagination={false}
          size="small"
        />
        <div className="common-modal__info-block">
          <div className="common-modal__info-container">
            <span className="column-title-font">Total weight:</span>
            <span className="column-content-font">{totalWeight} kg</span>
          </div>

          <div className="common-modal__info-container">
            <span className="column-title-font">Total:</span>
            <span className="column-content-font">{totalSum} rub.</span>
          </div>
          <div className="common-modal__info-container">
            <span className="column-title-font">Paid:</span>
            {paid ? (
              <span className="column-title-font" style={{ color: "green" }}>
                Yes
              </span>
            ) : (
              <span className="column-content-font" style={{ color: "red" }}>
                No
              </span>
            )}
          </div>
          <div className="common-modal__info-container">
            <span className="column-title-font">Total paid:</span>
            {cancelled ? (
              <span className="column-title-font" style={{ color: "red" }}>
                Cancelled
              </span>
            ) : (
              <span className="column-content-font">{totalSumPaid} rub.</span>
            )}
          </div>
          <div className="common-modal__info-container">
            <span className="column-title-font">Shipped:</span>
            {shipped ? (
              <span className="column-title-font" style={{ color: "green" }}>
                Yes
              </span>
            ) : (
              <span className="column-content-font" style={{ color: "red" }}>
                No
              </span>
            )}
          </div>
          {driverName && (
            <div className="common-modal__info-container">
              <span className="column-title-font">Driver:</span>
              <span className="column-title-font">{driverName}</span>
            </div>
          )}
          {deliveryAddress && (
            <div className="common-modal__info-container">
              <span className="column-title-font">Delivery address:</span>
              <span className="column-title-font">{deliveryAddress}</span>
            </div>
          )}
          {deliveryCost && (
            <div className="common-modal__info-container">
              <span className="column-title-font">Delivery cost:</span>
              <span className="column-title-font">{deliveryCost} rub.</span>
            </div>
          )}
          {comment && (
            <div className="common-modal__info-container">
              <span className="column-title-font">Comment:</span>
              <span className="column-content-font">{comment}</span>
            </div>
          )}
          <h3 className="common-modal-title">Payments:</h3>
          <Table
            dataSource={payments}
            columns={columnsForModalofPayments}
            pagination={false}
            size="small"
          />
        </div>
        <PrintOrderPopup
          order={selectedOrder}
          print={print}
          handlePrint={handlePrint}
        />
      </Card>
    );
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const columns = [
      {
        title: (
          <div>
            <FieldNumberOutlined /> / <CalendarOutlined />
          </div>
        ),
        dataIndex: "serial",

        key: "serial",
        render: (_, record) => (
          <span className="column-content-font">
            {record.serial} / {record.date}
          </span>
        ),
      },
      {
        title: <span className="table-title-font">Weight</span>,
        dataIndex: "totalWeight",
        key: "totalWeight",
        render: (text) => <span className="column-content-font">{text}kg</span>,
      },
      {
        title: <span className="table-title-font">Amount</span>,
        dataIndex: "totalSum",
        key: "totalSum",
        render: (text, record) =>
          record.cancelled ? (
            <span className="table-title-font">CANCELLED</span>
          ) : (
            <span className="column-content-font">{text} rub.</span>
          ),
      },

      {
        title: <span className="table-title-font">Actions</span>,
        key: "action",
        render: (text, record) => (
          <Space>
            <Button
              disabled={record.state === "complete" || record.cancelled}
              className="common-table-button"
              type="link"
              size="small"
              icon={
                <CarOutlined
                  style={{
                    color: record.cancelled
                      ? "inherit"
                      : record.shipped
                        ? "green"
                        : "red",
                  }}
                />
              }
              onClick={() => {
                if (record.shipped) {
                  showConfirmCancelShipping(record);
                } else {
                  showConfirmShipping(record);
                }
              }}
            />
            <Button
              disabled={
                record.state === "complete" || record.cancelled || record.paid
              }
              className="common-table-button"
              type="link"
              size="small"
              icon={
                <CreditCardOutlined
                  style={{
                    color: record.cancelled
                      ? "inherit"
                      : record.paid
                        ? "green"
                        : "red",
                  }}
                />
              }
              onClick={() => handlePayForOrder(record)}
            />
            <Button
              className="common-table-button"
              size="small"
              type="link"
              onClick={() => showModal(record)}
              icon={<EyeOutlined />}
            />
            <Button
              disabled={
                record.state === "complete" ||
                record.cancelled ||
                record.paid ||
                record.shipped ||
                record.returns.length > 0 ||
                record.payments.length > 0
              }
              className="common-table-button"
              type="link"
              size="small"
              icon={<EditOutlined />}
              onClick={() => handleEditOrder(record)}
            />
            <Button
              disabled={
                record.state === "complete" ||
                record.cancelled ||
                record.paid ||
                record.shipped ||
                record.returns.length > 0 ||
                record.payments.length > 0
              }
              className="common-table-button"
              type="link"
              size="small"
              icon={<DeleteOutlined />}
              onClick={() => showConfirmCancel(record)}
              danger
            />
          </Space>
        ),
      },
      {
        dataIndex: "state",
        key: "state",
        render: (text, record) => (
          <FileDoneOutlined
            style={{
              color:
                record.paid && !record.shipped
                  ? "green"
                  : !record.paid && record.shipped
                    ? "red"
                    : record.cancelled
                      ? "grey"
                      : record.state === "complete"
                        ? "yellow"
                        : "inherit",
            }}
          />
        ),
      },
    ];
    const columnsForModal = [
      {
        title: <span className="column-title-font">Title</span>,
        dataIndex: "title",
        key: "title",
        render: (text) => <span className="column-content-font">{text}</span>,
      },
      {
        title: <span className="column-title-font">Weight</span>,
        dataIndex: "weight",
        key: "weight",
        render: (text) => (
          <span className="column-content-font">{text} kg</span>
        ),
      },
      {
        title: <span className="column-title-font">Price</span>,
        dataIndex: "price",
        key: "price",
        render: (text) => (
          <span className="column-content-font">{text} rub</span>
        ),
      },
    ];
    const counteragentColumn = {
      title: <span className="column-title-font">Counteragent</span>,
      dataIndex: "counteragentName",
      key: "counteragentName",
      render: (text) => <span className="column-content-font">{text}</span>,
    };
    const costColumn = {
      title: <span className="column-title-font">Cost</span>,
      dataIndex: "cost",
      key: "cost",
      render: (text) => <span className="column-content-font">{text} rub</span>,
    };

    if (windowWidth > 375) {
      columns.splice(1, 0, counteragentColumn);
      columnsForModal.push(costColumn);
    }

    setColumns(columns);
    setColumnsForModal(columnsForModal);
  }, [windowWidth]);

  useEffect(() => {
    if (!counteragentOrders) {
      setLoading(true);
      return;
    }
    const filtered = filterOrders(filter, counteragentOrders, searchValue);
    const dataSource = prepareDataSource(filtered);
    setDataSource(dataSource);

    setLoading(false);
  }, [filter, counteragentOrders, searchValue]);

  return (
    <div className="common-container">
      <Spin spinning={loading}>
        <BackRouteButton />

        <span className="common-info-title">
          All orders of the counteragent: {selectedCounteragent.nameInfo}
        </span>
        <Input.Search
          placeholder="Search"
          onChange={handleSearchChange}
          style={{ marginBottom: 8 }}
          size="small"
        />
        <Radio.Group
          onChange={handleFilterChange}
          value={filter}
          style={{ marginBottom: 16 }}
          size="small"
        >
          <Radio.Button value="all">All</Radio.Button>
          <Radio.Button value="opened">Opened</Radio.Button>
          <Radio.Button value="complete">Completed</Radio.Button>
          <Radio.Button value="cancelled">Cancelled</Radio.Button>
          <Radio.Button value="notPayed">Unpaid</Radio.Button>
          <Radio.Button value="notShipped">Not Shipped</Radio.Button>
          <Radio.Button value="withReturns">With Returns</Radio.Button>
        </Radio.Group>

        <Table
          pagination={{ pageSize: 20 }}
          dataSource={dataSource}
          columns={columns}
        />
        <Modal
          open={isModalVisible}
          bodyStyle={{ marginTop: "20px" }}
          onCancel={handleCancel}
          footer={null}
        >
          <OrderModalContent />
        </Modal>
      </Spin>
    </div>
  );
};
